var NumberUtilities = /** @class */ (function () {
    function NumberUtilities() {
    }
    NumberUtilities.pad2 = function (number) {
        return (number < 10 ? "0" : "") + number;
    };
    NumberUtilities.prototype.pad = function (num, size) {
        var s = num + "";
        while (s.length < size)
            s = "0" + s;
        return s;
    };
    NumberUtilities.roundToTwo = function (num) {
        return +(Math.round(Number(num + "e+2")) + "e-2");
    };
    return NumberUtilities;
}());
export { NumberUtilities };
